import { render, staticRenderFns } from "./MiniCalendarView.vue?vue&type=template&id=3b8da8fc&scoped=true"
import script from "./MiniCalendarView.vue?vue&type=script&lang=js"
export * from "./MiniCalendarView.vue?vue&type=script&lang=js"
import style0 from "./MiniCalendarView.vue?vue&type=style&index=0&id=3b8da8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8da8fc",
  null
  
)

export default component.exports